const NavigationEmail = () => {
  return (
    <section className="menu-email">
      <span className="myemail-txt">&lt; / santhoshbalaji304@gmail.com &gt;</span>
    </section>
  );
};

export default NavigationEmail;
